import { Skeleton } from "@/components/ui/skeleton";

const GroupSkeleton = ({ items = 3 }) => (
  <div>
    <div className="flex items-center gap-x-2 px-2 py-2">
      <Skeleton className="h-3.5 w-3.5 shrink-0" />
      <Skeleton className="h-3.5 w-28 flex-1" />
      <Skeleton className="h-3.5 w-5" />
    </div>
    <div className="ml-2 space-y-0.5">
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} className="flex items-center gap-x-3 px-2 py-2">
          <Skeleton className="h-4 w-4 rounded-full shrink-0" />
          <div className="min-w-0 flex-1 space-y-1.5">
            <Skeleton className="h-3 w-14" />
            <Skeleton className="h-3 w-full max-w-[180px]" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

const DisclosureSidebarSkeleton = () => (
  <div className="flex flex-col gap-y-3 pt-4">
    <div className="flex items-center gap-x-2">
      <Skeleton className="h-9 flex-1" />
      <Skeleton className="h-8 w-8 shrink-0" />
      <Skeleton className="h-8 w-8 shrink-0" />
    </div>
    <div className="space-y-1">
      <GroupSkeleton items={4} />
      <GroupSkeleton items={3} />
      <GroupSkeleton items={3} />
    </div>
  </div>
);

export default DisclosureSidebarSkeleton;
